module.exports = __webpack_public_path__ + "img/exante_assistenza_nucleo.e7d7996a.jpg";